import React from "react";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import Location from "../../assets/images/Capture-2.png";
import ContactUs from "./ContactUs";
export default function Locations() {
  const locations = [
    {
      title: "5 Min Away from",
      places: [
        "The Gaudium School",
        "Rainbow International School",
        "International School of Hyderabad",
        "Fusion International School",
        "Sancta Maria International School",
        "University of Hyderabad",
        "SVS Hospital",
        "Sai Krishna Multi Speciality Hospital",
        "ESI Hospital",
        "GHMC Park",
        "Outer Ring Road",
        "BHEL",
        "Ordinance Factory Medak Office",
      ],
    },
    {
      title: "10 Min Away from",
      places: [
        "Oakdale International School",
        "Samashti International School",
        "Birla Open Mind International School",
        "Green Gables International School",
        "RRS College of Engineering and Technology",
        "Amaltas Green School",
        "Sri Chaitanya High School",
        "Krishnaveni High School",
        "Narayana IIT Academy",
        "Ellenki College of Engineering and Technology",
      ],
    },
    {
      title: "15 Min Away from",
      places: [
        "Financial District(ORR)",
        "Gachibowli Cross Road",
        "Hindalco Industries Ltd.",
        "TSIIC Hub",
        "Manjeera Junior College",
        "St. Mary’s College of Engineering and Technology",
        "IIT, Hyderabad",
        "Continental Hospital",
        "Peoples Hospital",
        "Sai Ganesh Multi-speciality Hospital",
      ],
    },
  ];

  return (
    <div>
      <div className="bg-[#fdf6f6] xl:py-16 py-10" id="location">
        <div className="max-w-screen-xl mx-auto px-6">
          <h2 className="font-crimson text-3xl xl:text-5xl pb-5 text-[#5e3920] text-center">
            A Well-Connected Location Near Patancheru & ORR
          </h2>
          <p className="text-[#000000d9] max-w-3xl mx-auto text-center text-[16px] pb-5 mb-5 xl:text-[18px] font-inter leading-relaxed">
            Located in Nandigaon, Patancheru, Aura offers access to schools,
            healthcare, everyday conveniences and major employment destinations
            listed below. The location also provides access to the Outer Ring
            Road and connectivity towards Hyderabad's key business areas.
          </p>
          <div className="flex justify-center items-center my-7 relative">
            <div
              className="absolute right-1 top-1/3"
              style={{
                writingMode: "vertical-rl",
              }}
            >
              <h3 className="font-bold">RERA Number - PO1100004193</h3>
            </div>
            <img
              src={Location}
              className="w-full"
              alt="A Well-Connected Location Near Patancheru & ORR"
            />
          </div>
          <h2 className="font-crimson text-3xl xl:text-5xl pb-5 pt-10 text-[#5e3920] text-center">
            Schools, Hospitals & IT Hubs Near Aura
          </h2>
          <p className="text-[#000000d9] max-w-3xl mx-auto text-center text-[16px] pb-5 mb-5 xl:text-[18px] font-inter leading-relaxed">
            Aura is surrounded by a range of educational institutions, healthcare facilities, parks, employment destinations and business hubs. The distances below are presented according to the project's current location information.
          </p>
          <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10 mt-10">
            {locations.map((section, idx) => (
              <div key={idx} className="w-full h-auto">
                <p className="font-crimson xl:text-3xl text-2xl font-semibold py-5 text-[#5e3920] ">
                  {section.title}
                </p>
                <ul className="font-inter text-[18px]">
                  {section.places.map((place, index) => (
                    <li
                      key={index}
                      className="grid grid-cols-[auto_1fr] items-start gap-2 mb-2"
                    >
                      <MyLocationIcon sx={{ color: "#5e3920" }} />
                      <span>{place}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ContactUs />
    </div>
  );
}
